export const heroFechamentoContent = {
  title: "pastejo",
  tagline: "a rotina da fazenda\nconvertida em controle,\ndados e resultado.",
} as const;
